import { render, staticRenderFns } from "./NewsletterModerator.vue?vue&type=template&id=b626cfc2&"
import script from "./NewsletterModerator.vue?vue&type=script&lang=js&"
export * from "./NewsletterModerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b626cfc2')) {
      api.createRecord('b626cfc2', component.options)
    } else {
      api.reload('b626cfc2', component.options)
    }
    module.hot.accept("./NewsletterModerator.vue?vue&type=template&id=b626cfc2&", function () {
      api.rerender('b626cfc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/newsletter/moderator/NewsletterModerator.vue"
export default component.exports